import { OrderItem } from '@libs/api-reference';
import { transformTradePriceChange } from '@core/symbol';

export function updateTradePrice(
  orders: OrderItem[],
  socketData: ReturnType<typeof transformTradePriceChange>
) {
  orders.forEach((s, i) => {
    if (
      s.instrumentIdentification === socketData.isin &&
      socketData.lastTradePrice !== orders[i].lastTradePrice
    ) {
      const prevData = orders[i];

      Object.assign(orders[i], {
        ...prevData,
        lastTradePrice: socketData.lastTradePrice,
      });
    }
  });
}
